// extracted by mini-css-extract-plugin
export var actionButton = "_eq-t";
export var buttonContainer = "_eq-0";
export var buttonContainer2 = "_eq-1";
export var buttonSection = "_eq-2";
export var details = "_eq-3";
export var dropdownItem = "_eq-5";
export var dropdownItemsContainer = "_eq-4";
export var fileInput = "_eq-r";
export var headerButton = "_eq-6";
export var icon = "_eq-7";
export var input = "_eq-8";
export var macroListItem = "_eq-9";
export var mainContent = "_eq-a";
export var microText = "_eq-b";
export var modal = "_eq-w";
export var optionsButton = "_eq-c";
export var paperclip = "_eq-s";
export var pillContent = "_eq-d";
export var preview = "_eq-e";
export var preview2 = "_eq-f";
export var quillEditor = "_eq-q";
export var selectedMacro = "_eq-g";
export var sidebar = "_eq-h";
export var sidebarHeader = "_eq-j";
export var sidebarList = "_eq-i";
export var sidebarListItem = "_eq-k";
export var sidebarSearch = "_eq-l";
export var snoozeDurationWrapper = "_eq-v";
export var statusPillContainer = "_eq-m";
export var tagsContainer = "_eq-n";
export var unselectedMacro = "_eq-o";
export var variable = "_eq-u";
export var wrapper = "_eq-p";